// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ``, "",{"version":3,"sources":[],"names":[],"mappings":"","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primaryColor": `#008895`,
	"primaryColorMidTransparent": `#59b2bb`,
	"primaryColorTransparent": `rgba(0,137,149,.3058823529)`,
	"secondaryColor": `#ed40a9`,
	"secondaryColorTransparent": `rgba(237,64,168,.462745098)`,
	"cardTitleBackground": `#839fb0`,
	"searchButtonBackground": `#5b7e96`,
	"backdropBackground": `#22323e`,
	"white": `#fff`,
	"darkWhite": `#f7f7f7`,
	"black": `#000`,
	"lightGrey": `#f4f4f4`,
	"lightGrey2": `#f2f2f2`,
	"medGrey": `#e4e4e4`,
	"darkGrey": `#c4c4c4`,
	"midDarkGrey": `#bbb`,
	"extraDarkGrey": `#bebebe`,
	"red": `red`,
	"blue": `#007fff`,
	"linkBlue": `#0d7cce`,
	"blueGrey": `#bbc6d0`,
	"lightPurple": `#f0f2ff`,
	"tableRow": `#c1e9ed`,
	"columnHeader": `#d4dde4`,
	"columnHeaderTitle": `#222`
};
export default ___CSS_LOADER_EXPORT___;
